import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import icon from 'flarum/common/helpers/icon';
import listItems from 'flarum/common/helpers/listItems';
import IndexPage from 'flarum/forum/components/IndexPage';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';

export default class QuestionnaireList extends Page {
  oninit(vnode: any) {
    super.oninit(vnode);
    app.history.push('questionnaires', app.translator.trans('tohsakarat-questionnaire.forum.list.title'));
    this.loading = true;
    this.questionnaires = [];
    this.loadQuestionnaires();
  }

  loadQuestionnaires() {
    this.loading = true;

    app.store
      .find('qwn-questionnaires')
      .then((results: any) => {
        this.questionnaires = results;
        this.loading = false;
        this.setTitle();
        m.redraw();
      })
      .catch(() => {
        this.loading = false;
        this.setTitle();
        m.redraw();
      });
  }

  oncreate(vnode: any) {
    super.oncreate(vnode);
    this.setTitle();
  }

  setTitle() {
    app.setTitle(app.translator.trans('tohsakarat-questionnaire.forum.list.title'));
    app.setTitleCount(0);
  }

  canAttempt(questionnaire: any): boolean {
    if (!questionnaire) return false;
    const val = questionnaire.attribute('canAttempt');
    return val === undefined || val === true;
  }

  view() {
    return (
      <div className="IndexPage IndexPage--questionnaires">
        <WelcomeHero />
        <div className="container">
          <div className="sideNavContainer">
            <nav className="IndexPage-nav sideNav">
              <ul>{listItems(IndexPage.prototype.sidebarItems().toArray())}</ul>
            </nav>
            <div className="IndexPage-results sideNavOffset">
              <div className="qwn-list-page">
                <div className="qwn-list-page__hero">
                  <h2 className="qwn-list-page__title">
                    {icon('fas fa-clipboard-list')}
                    {app.translator.trans('tohsakarat-questionnaire.forum.list.title')}
                  </h2>
                  <p className="qwn-list-page__subtitle">
                    {app.translator.trans('tohsakarat-questionnaire.forum.list.subtitle')}
                  </p>
                </div>

                {this.loading ? (
                  <div className="qwn-list-page__loading">
                    <LoadingIndicator />
                  </div>
                ) : this.questionnaires.length === 0 ? (
                  <div className="qwn-list-page__empty">
                    <p>{app.translator.trans('tohsakarat-questionnaire.forum.list.empty')}</p>
                  </div>
                ) : (
                  <div className="qwn-questionnaire-grid">
                    {this.questionnaires.map((qwn: any) => this.renderCard(qwn))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCard(questionnaire: any) {
    if (!questionnaire) return null;

    const accessible = this.canAttempt(questionnaire);
    const isPassed = questionnaire.attribute('isPassed') === true;

    // 直接通过 attribute 获取，确保在不同环境下的稳定性
    const rawCoverUrl = questionnaire.attribute('coverUrl');
    const hasCover = rawCoverUrl && String(rawCoverUrl).trim() !== '' && String(rawCoverUrl).startsWith('http');
    const title = questionnaire.title ? questionnaire.title() : '';
    const description = questionnaire.description ? questionnaire.description() : '';

    const cardContent = [
      hasCover ? (
        <div className="qwn-questionnaire-card__cover">
          <img src={rawCoverUrl} alt={title} />
        </div>
      ) : null,
      <div className="qwn-questionnaire-card__body">
        <h3 className="qwn-questionnaire-card__title">{title}</h3>

        {description && (
          <p className="qwn-questionnaire-card__description">{description}</p>
        )}

        {isPassed ? (
          <p className="qwn-questionnaire-card__locked-tip" style={{ color: 'var(--success-color, #4CAF50)' }}>
            {icon('fas fa-medal')}
            已通关
          </p>
        ) : !accessible ? (
          <p className="qwn-questionnaire-card__locked-tip">
            {icon('fas fa-lock')}
            {app.translator.trans('tohsakarat-questionnaire.forum.list.locked_tip')}
          </p>
        ) : null}
      </div>
    ];

    // 组合类名
    const canClick = accessible || isPassed;
    const classes = ['qwn-questionnaire-card'];
    classes.push(canClick ? 'qwn-questionnaire-card--accessible' : 'qwn-questionnaire-card--locked');
    if (!hasCover) {
      classes.push('qwn-questionnaire-card--no-cover');
    }
    const className = classes.join(' ');

    if (canClick) {
      return (
        <Link
          key={questionnaire.id()}
          className={className}
          href={app.route('questionnairePage', { id: questionnaire.id() })}
        >
          {cardContent}
        </Link>
      );
    }

    return (
      <div key={questionnaire.id()} className={className}>
        {cardContent}
      </div>
    );
  }
}
